// extracted by css-extract-rspack-plugin
var _1 = "wo6iWcko8x8Lkuxq";
var _2 = "PB5on122P9ccoXLX";
var _3 = "PB5on122P9ccoXLX";
export { _1 as "carousel", _2 as "carouselTitle", _3 as "carousel__title" }
